<template>
	<b-form>
		<b-form-group id="input-tag" :label="'Nombre'" label-for="txtName" class="is-valid">
			<b-form-input
				id="txtName"
				v-model.trim="tagCopy.name"
				type="text"
				class="style2"
				:disabled="!editMode || updating"
			></b-form-input>
		</b-form-group>
		<b-form-invalid-feedback v-if="error">
			El nombre es obligatorio
		</b-form-invalid-feedback>
		<b-form-group
			id="input-color-tag"
			:label="'Color'"
			label-for="txtColor"
			class="is-valid"
		>
			<b-form-input
				id="txtColor"
				v-model="tagCopy.color"
				type="color"
				class="style2 w-25"
				:disabled="!editMode || updating"
			></b-form-input>
		</b-form-group>

		<div class="d-flex flex-wrap justify-content-end align-items-center btn-wrap">
			<b-button type="button" @click="$router.back()" :disabled="updating">{{
				$t('lang.buttons.back')
			}}</b-button>
			<template v-if="editMode">
				<b-button @click="handleSaveClick" :disabled="updating"
					>{{ $t('lang.buttons.confirm') }}
					<template v-if="updating">
						<b-spinner variant="primary" label="Spinning" small></b-spinner>
					</template>
				</b-button>
			</template>
		</div>
	</b-form>
</template>

<script>
import { mapActions } from 'vuex';

export default {
	props: {
		tag: {
			type: Object,
			required: true
		},
		editMode: {
			type: Boolean,
			default: false
		}
	},
	created() {
		this.tagCopy = { ...this.tag };
	},
	data: () => ({
		updating: false,
		tagCopy: {},
		error: false
	}),
	methods: {
		...mapActions('tagsStore', ['putTag']),

		async handleSaveClick() {
			if (this.isValid()) {
				try {
					this.updating = true;
					await this.putTag({ ...this.tagCopy, id: this.tagCopy._id });
					this.$emit('updated');
					// this.$router.back();
				} catch (error) {
					console.log(error);
				} finally {
					this.updating = false;
				}
			}
		},

		isValid() {
			let res = this.tagCopy && this.tagCopy.name.trim().length > 0;
			this.error = !res;
			return res;
		}
	}
};
</script>
